<template>
  <div class="right_box">
    <div class="PcshowBox">
      <el-table
        :data="table.data"
        class="tableBox"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width:100%"
        stripe
      >
        <el-table-column
          min-width="40%"
          label="资源"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.RESTYPE=='1'" class="templateName" style="background-color: #66f788;">谱书</span>
              <span v-if="scope.row.RESTYPE=='2'" class="templateName" style="background-color: #317ee7;">谱文</span>
              <span v-if="scope.row.RESTYPE=='3'" class="templateName" style="background-color: #e869f3;">谱系</span>
              <span class="content_name">{{ scope.row.TITLE }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="25%"
          prop="CREATE_DATE"
          label="发布时间"
          sortable
        />
        <el-table-column
          min-width="15%"
          label="操作"
        >
          <template slot-scope="scope">
            <span class="Btn" @click="goDetail(scope.row)">
              阅读
            </span>
            <!--<span class="cancelBtn" @click="cancelRemove(scope.row)">删除</span>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <pagination
        :total="table.count"
        :pager="table.param.index"
        :pagesize="table.param.size"
        style="text-align:center;margin:40px 0 60px;"
        layout="sizes, pager, next, jumper"
        @pagersizechange="pagerSizeChange"
        @pagerchange="pagerChange"
      />
    </div>
  </div>
</template>

<script>
import pagination from '@/components/userCenter/pagination.vue'
import { findUserFamilyTree } from '@/api/api.js'
export default {
  components: {
    pagination
  },
  inject: ['reload'],
  data() {
    return {
      zgw1: require('@/static/zgw1.png'),
      zgw2: require('@/static/zgw2.png'),
      py1: require('@/static/py1.png'),
      py2: require('@/static/py2.png'),
      currentSet: 1,
      value1: '全部分类', // ////选择的分类
      value2: '', // ///搜索值
      ISShow: true,
      currentTypeIndex: 0,
      table: {
        data: [],
        param: {
          index: 1,
          size: 10
        },
        count: 0
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findUserFamilyTree(this.table.param).then(response => {
        this.table.data = response.data.listMapData
        this.table.count = response.data.count
        // console.log(this.table.data)
      })
    },
    pagerSizeChange: function(size) {
      this.table.param.size = size
      this.table.param.index = 1
      this.fetchData()
    },
    pagerChange: function(pager) {
      this.table.param.index = pager
      this.fetchData()
    },
    // //取消收藏单个和批量删除
    goDetail: function(item) {
      var href = ''
      href = 'sourceView?sourceId=' + item.ID + '&type=' + item.RESTYPE
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .cellSty{
        .cell{
            padding-left: 20px!important;
        }
    }
    .phoneBox{
        display: none;
    }
    .right_box{
        width: 100%;
        display: inline-block;
        vertical-align: top;
        background-color: #fff;
        overflow: hidden;
        .tips{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 30px;
            font-size: 18px;
        }
    }

    .toptitle {
        line-height: 40px;
        height: 40px;
        border-bottom: 1px solid #e5e5e5;
        span {
            display: inline-block;
            height: 39px;
            font-size: 14px;
            color: #4e4e4e;
            width: 72px;
            border-bottom: 2px solid #ed4040;
        }
    }
    .searchs{
        width: 217px;
        display: inline-block;
        margin-left: 12px;
        vertical-align: middle;
    }
    .collect_search{
        display: inline-block;
        position: absolute;
        width: 30px;
        height: 40px;
        font-size: 18px;
        line-height: 40px;
        color: #b3b3b3;
        right: 0;
        cursor: pointer;
    }
    .searchBox{
        position: relative;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
    }
    .topBox{
        padding: 18px 30px;
        padding-left: 10px;
        background-color: #F1F7FF;
        margin-bottom: 15px;
        .btnType1{
            padding: 5px 20px;
            border: 1px solid #E0466E;
            border-radius: 3px;
            color: #ffffff;
            font-size: 14px;
            background-color: #E0466E;
            margin-left: 15px;
            cursor: pointer;
        }
        .btnType1_no{
            padding: 5px 20px;
            border: 1px solid #E5E5E5;
            border-radius: 3px;
            color: #333333;
            font-size: 14px;
            background-color: #fff;
            margin-left: 15px;
            cursor: pointer;
        }
    }
    .selects{
        position:relative;
    }
    .quxiao{
        background-color: #ed4040!important;
        border: none!important;
    }
    .Btn{
        color: #5aa0fd;
        font-size: 14px;
        cursor: pointer;
    }
    ///收藏的单个删除功能添加
    .cancelBtn{
        color: #e0466e;
        font-size: 14px;
        margin-left: 10px;
        cursor: pointer;
    }
    .templateName{
        width: 38px;
        height: 22px;
        display: inline-block;
        color: #ffffff;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        border-radius: 3px;
        margin-right: 10px;
    }
    .content_name{
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        color: #333333;
        max-width: 330px;
        overflow: hidden;
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .myCollContent{
            padding: 0 10px;
        }
        .selects{
            width: 30vw;
        }
        .searchBox{
            width: 50vw;
        }
        .searchs{
            width: 45vw;
        }
        .PcshowBox{
            display: none;
        }
        .phoneBox{
            display: block;
            padding-top: 20px;
            .phoneList{
                position: relative;
                margin: 20px 0;
                .phoneNames{
                    width: calc( 100vw -  100px);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow:ellipsis
                }
                .cancelBtn{
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }

        }

    }
</style>
<style rel="stylesheet/scss" lang="scss">
    .myCollContent{
        .el-table .cell{
            padding-left: 30px!important;
        }
    }
</style>
